// import React from "react";
// import { FaCamera, FaFilePdf } from "react-icons/fa";
// import { all_routes } from "../../router/all_routes";
// import { Link } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { Table } from "antd";

// interface MyApplicationData {
//     [x: string]: any;
//     key: string;

//     ApplicantName: string;
//     ApplicantType: string;
//     DateOfApplication: string;
//     ApplicationStatus: string;
//     IsThisAPartnershipFirm: string;
//   }
//   interface Data {

//     key: string;

//     ApplicantType: string;

//     IsThisAPartnershipFirm: string;
//   }

//   const columns = [
//     {
//       title: "Applicant Name",
//       dataIndex: "ApplicantName",
//       sorter: (a: MyApplicationData, b: MyApplicationData) =>
//         a.ApplicationName.length - b.ApplicationName.length,
//     },

//     {
//       title: "Applicant Type",
//       dataIndex: "ApplicantType",
//       sorter: (a: MyApplicationData, b: MyApplicationData) =>
//         a.ApplicantType.length - b.ApplicantType.length,
//     },
//     {
//       title: "Date Of Application",
//       dataIndex: "DateOfApplication",
//       sorter: (a: MyApplicationData, b: MyApplicationData) =>
//         a.DateOfApplication.length - b.DateOfApplication.length,
//     },

//     {
//       title: "Application Status",
//       dataIndex: "ApplicationStatus",
//       sorter: (a: MyApplicationData, b: MyApplicationData) =>
//         a.ApplicationStatus.length - b.ApplicationStatus.length,
//     },
//   ];

// const PendingPE: React.FC = () => {

//   const [uploadedFiles, setUploadedFiles] = useState<Record<string, string>>(
//     {}
//   );

//   const [selectedActions, setSelectedActions] = useState<string>("");

//     const initialData: MyApplicationData[] = [
//       {
//         key:"1",

//         ApplicantName: "Akshit Singh",
//         ApplicantType: "Individual",
//         DateOfApplication: "2022-2024",
//         ApplicationStatus: "Pending",
//       },
//       {
//         key:"2",

//         ApplicantName: "Akshit Singh",
//         ApplicantType: "Individual",
//         DateOfApplication: "2022-2024",
//         ApplicationStatus: "Pending",
//       },
//       {
//         key:"3",

//         ApplicantName: "Akshit Singh",
//         ApplicantType: "Individual",
//         DateOfApplication: "2022-2024",
//         ApplicationStatus: "Pending",
//       },
//     ];

//     const Data: Data[] = [
//         {
//           key:"1",

//           ApplicantName: "Akshit Singh",
//          IsThisAPartnershipFirm:"yes",
//         },
//         {
//             key:"2",

//             ApplicantName: "Akshit Singh",
//            IsThisAPartnershipFirm:"yes",
//           },
//           {
//             key:"2",

//             ApplicantName: "Akshit Singh",
//            IsThisAPartnershipFirm:"yes",
//           },
//       ];

//     const filteredData = selectedActions
//     ? initialData.filter((item) => item.ApplicationStatus === selectedActions)
//     : initialData;

//     const Data = selectedActions
//     ? Data.filter((item) => item.ApplicationStatus === selectedActions)
//     : Data;

//   const handleFileChange = (
//     e: React.ChangeEvent<HTMLInputElement>,
//     index: number,
//     type: string
//   ) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       setUploadedFiles((prev) => ({
//         ...prev,
//         [`${index}-${type}`]: URL.createObjectURL(file),
//       }));
//     }
//   };

//   return (
//     <div>
//       <div className="page-wrapper cardhead">
//         <div className="content container-fluid">
//           <div className="page-header">
//             <div className="row">
//               <div className="col">
//                 <h3 className="page-title">Track Application Status </h3>
//                 {/* <ul className="breadcrumb">
//                     <li className="breadcrumb-item">
//                       <Link to={routes.adminDashboard}>Dashboard</Link>
//                     </li>
//                     <li className="breadcrumb-item active">Horizontal Form</li>
//                   </ul> */}
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-xl-12">
//               <div className="card">
//                 <div className="card-header">
//                   <h5 className="card-title">Application Details</h5>
//                 </div>
//                 <div className="card-body">
//                   <Table dataSource={filteredData} columns={columns} />
//                 </div>

//               </div>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-xl-12">
//               <div className="card">
//                 <div className="card-body">
//                   <div>
//                     <h5 className="mb-2">Current Address:</h5>
//                     <div className="card-body">
//                     <div className="card-body">
//                   <Table dataSource={Data} columns={columns} />
//                 </div>

//                     </div>
//                   </div>
//                   <div>
//                     <h5 className="mb-2">Permanent Address:</h5>
//                     <div className="card-body">

//                     </div>
//                   </div>
//                   <div className="mb-3">
//                     <h5 className="mb-2">Registered Office Address:</h5>

//                     {/* Office Address Table */}
//                     <div className="card-body">

//                     </div>

//                     {/* Office Details Table */}
//                     <div className="card-body">

//                     </div>
//                   </div>

//                   <div>
//                     <h5 className="mb-2">Representatives or Assistants:</h5>
//                     <div className="card-body">

//                     </div>
//                   </div>
//                   <div>
//                     <h5 className="mb-2">Directors/Partners/Members:</h5>
//                     <div className="card-body">

//                     </div>
//                   </div>
//                   <div>
//                     <h5 className="mb-2">Enclosures:</h5>
//                     <div className="card-body">
//                       <div className="card-body">
//                         <div className="table-responsive">
//                           <div className="flex items-center gap-3 p-2 border rounded-md bg-gray-100">
//                             <i className="fa fa-file-pdf text-red-600 text-2xl"></i>

//                             <a
//                               href="/path-to-your-pdf.pdf"
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="text-blue-600 font-semibold hover:underline"
//                             >
//                               View PDF Document
//                             </a>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div>
//                     <h5 className="mb-2">Guarantor Details:</h5>
//                     <div className="card-body">

//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PendingPE;

import React, { useState } from "react";
import { Button, Table } from "antd";

interface MyApplicationData {
  key: string;
  ApplicantName: string;
  ApplicantType: string;
  DateOfApplication: string;
  ApplicationStatus: string;
  IsThisAPartnershipFirm?: string;
}

interface Data {
  key: string;
  ApplicantName: string;
  IsThisAPartnershipFirm: string;
}

interface EducationData {
  key: string;
  SrNo: string;
  Education: string;
  Attachment: string;
}

interface ProjectData {
  key: string;
  SrNo: string;
  ProjectName: string;
  Attachment: string;
  StartDate: string;
  EndDate: string;
}

interface PersonData {
  key: string;
  SrNo: number;
  Name: string;
  Age: number;
  Address: string;
}
interface LocationData {
  key: string;
  Address: string;
  Post: string;
  Taluka: string;
  District: string;
}
interface UserData {
  key: string;
  Email: string;
  MobileNo: string;
  DOB: string;
}

const columns1 = [
  {
    title: "Sr No.",
    dataIndex: "SrNo",
    sorter: (a: PersonData, b: PersonData) => a.SrNo - b.SrNo,
  },
  {
    title: "Name",
    dataIndex: "Name",
    sorter: (a: PersonData, b: PersonData) => a.Name.localeCompare(b.Name),
  },
  {
    title: "Age (years)",
    dataIndex: "Age",
    sorter: (a: PersonData, b: PersonData) => a.Age - b.Age,
  },
  {
    title: "Address",
    dataIndex: "Address",
  },
];
const columns4 = [
  {
    title: "Address",
    dataIndex: "Address",
  },
  {
    title: "Post",
    dataIndex: "Post",
  },
  {
    title: "Taluka",
    dataIndex: "Taluka",
  },
  {
    title: "District",
    dataIndex: "District",
  },
];
const columns5 = [
  {
    title: "Registered Email ID",
    dataIndex: "Email",
  },
  {
    title: "Mobile No",
    dataIndex: "MobileNo",
  },
  {
    title: "Date of Birth (DOB)",
    dataIndex: "DOB",
  },
];
const columns6 = [
  {
    title: "Sr. No.",
    dataIndex: "SrNo",
  },
  {
    title: "Education",
    dataIndex: "Education",
  },
  {
    title: "Attachment",
    dataIndex: "Attachment",
    render: (text: string) => (
      <Button type="link" href={text} target="_blank">
        View Attachment
      </Button>
    ),
  },
];
const columns7 = [
  {
    title: "Sr. No.",
    dataIndex: "SrNo",
  },
  {
    title: "Project Name",
    dataIndex: "ProjectName",
  },
  {
    title: "Attachment",
    dataIndex: "Attachment",
    render: (text: string) => (
      <Button type="link" href={text} target="_blank">
        View Attachment
      </Button>
    ),
  },
  {
    title: "Start Date",
    dataIndex: "StartDate",
  },
  {
    title: "End Date",
    dataIndex: "EndDate",
  },
];

const columns = [
  {
    title: "Applicant Name",
    dataIndex: "ApplicantName",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.ApplicantName.localeCompare(b.ApplicantName),
  },
  {
    title: "Applicant Type",
    dataIndex: "ApplicantType",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.ApplicantType.localeCompare(b.ApplicantType),
  },
  {
    title: "Date Of Application",
    dataIndex: "DateOfApplication",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.DateOfApplication.localeCompare(b.DateOfApplication),
  },
  {
    title: "Application Status",
    dataIndex: "ApplicationStatus",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.ApplicationStatus.localeCompare(b.ApplicationStatus),
  },
];

const columns2 = [
  {
    title: "Applicant Name",
    dataIndex: "ApplicantName",
  },
  {
    title: "Is This a Partnership Firm?",
    dataIndex: "IsThisAPartnershipFirm",
  },
];

const PendingPE: React.FC = () => {
  const [selectedActions, setSelectedActions] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileUrl, setFileUrl] = useState<string>("");

  // Handle file selection
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      setSelectedFile(file);
      setFileUrl(URL.createObjectURL(file)); // Create a temporary URL to preview the file
    }
  };
  const [projectData, setProjectData] = useState<ProjectData[]>([
    {
      key: "1",
      SrNo: "1",
      ProjectName: "AI Chatbot",
      Attachment: "/files/ai-chatbot.pdf",
      StartDate: "2023-01-15",
      EndDate: "2023-12-30",
    },
  ]);
  const [peopleData, setPeopleData] = useState<PersonData[]>([
    { key: "1", SrNo: 1, Name: "Alice", Age: 25, Address: "123 Main St, NY" },
  ]);

  const [locationData, setLocationData] = useState<LocationData[]>([
    {
      key: "1",
      Address: "123 Main St",
      Post: "Post A",
      Taluka: "Taluka X",
      District: "District M",
    },
  ]);
  const [userData, setUserData] = useState<UserData[]>([
    {
      key: "1",
      Email: "john.doe@example.com",
      MobileNo: "9876543210",
      DOB: "1990-05-15",
    },
  ]);

  const initialData: MyApplicationData[] = [
    {
      key: "1",
      ApplicantName: "Akshit Singh",
      ApplicantType: "Individual",
      DateOfApplication: "2022-2024",
      ApplicationStatus: "Pending",
    },
    {
      key: "2",
      ApplicantName: "John Doe",
      ApplicantType: "Company",
      DateOfApplication: "2023-2025",
      ApplicationStatus: "Approved",
    },
    {
      key: "3",
      ApplicantName: "Jane Smith",
      ApplicantType: "Individual",
      DateOfApplication: "2021-2023",
      ApplicationStatus: "Rejected",
    },
  ];

  const data: Data[] = [
    {
      key: "1",
      ApplicantName: "Akshit Singh",
      IsThisAPartnershipFirm: "Yes",
    },
    {
      key: "2",
      ApplicantName: "John Doe",
      IsThisAPartnershipFirm: "No",
    },
  ];

  const [educationData, setEducationData] = useState<EducationData[]>([
    {
      key: "1",
      SrNo: "1",
      Education: "Bachelor's in Computer Science",
      Attachment: "/files/bachelor-degree.pdf",
    },
  ]);
  const filteredData = selectedActions
    ? initialData.filter((item) => item.ApplicationStatus === selectedActions)
    : initialData;

  const filteredData2 = selectedActions
    ? data.filter((item) => item.IsThisAPartnershipFirm === selectedActions)
    : data;

  return (
    <div>
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Track Application Status</h3>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Application Details</h5>
                </div>
                <div className="card-body">
                  <Table dataSource={filteredData} columns={columns} />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div>
                    <div className="card-body">
                      <Table dataSource={filteredData2} columns={columns2} />
                    </div>
                  </div>

                  <div>
                    <h5 className="mb-2">Partners Details:</h5>
                    <div className="card-body">
                      <Table dataSource={peopleData} columns={columns1} />
                    </div>
                  </div>

                  <div className="mb-3">
                    <h5 className="mb-2">Registered Office Address:</h5>
                    <Table dataSource={locationData} columns={columns4} />
                    <Table dataSource={userData} columns={columns5} />
                    <div className="card-body"></div>
                  </div>
                  <div>
                    <h5 className="mb-2">Education Details:</h5>
                    <div className="card-body">
                      <Table dataSource={educationData} columns={columns6} />
                    </div>
                  </div>

                  <div>
                    <h5 className="mb-2">Experience Details:</h5>
                    <div className="card-body">
                      <Table dataSource={projectData} columns={columns7} />
                    </div>
                  </div>

                  <div>
                    <h5 className="mb-2">
                      How Many Years Have you been Working As a Business
                      Engineer
                    </h5>
                    <div className="card-body">
                      Details
                      {/* <Table dataSource={projectData} columns={columns7}/> */}
                    </div>
                  </div>

                  <div>
                    <h5 className="mb-2">Work Performed Details:</h5>
                    <div className="card-body">
                      <Table dataSource={projectData} columns={columns7} />
                    </div>
                  </div>

                  <div>
                    <h5 className="mb-2">Done Construction Details:</h5>
                    <div className="card-body">
                      <Table dataSource={projectData} columns={columns7} />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <h5 className="mb-2">IT Returns for The last 3 years</h5>
                     

                    
                    </div>
                    <div className="col-md-6">
                      <h5 className="mb-2">Applicant details</h5>
                    </div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingPE;
